// src/features/products/userAuthApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";

export const businessApi = createApi({
  reducerPath: 'businessApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.business.get }),
  tagTypes: ['businessApi'],
  endpoints: (builder) => ({
    getBusiness: builder.query({
      query: () => "getBusiness",
      keepUnusedDataFor: 35,
      providesTags: ['businessApi'],
      invalidatesTags: ['businessApi'],
    }),
    createBusiness: builder.mutation({
      query: (dataBusinesses) => {
       
        return {
          url: Urls.business.update+dataBusinesses.id,
          method: 'PUT',
          body: dataBusinesses,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['businessApi'], 
    }),
  }),
  keepUnusedDataFor: 1,

});



export const {
 useCreateBusinessMutation,
 useGetBusinessQuery
} = businessApi;
